import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminFaq: React.FC = () => (
  <ComingSoon
    icon="❓"
    title="FAQ 관리"
    features={[
      "FAQ 목록 조회 및 검색",
      "FAQ 작성 · 수정 · 삭제",
      "카테고리 분류 관리",
      "답변 노출 순서 정렬",
      "자주 묻는 항목 상단 고정",
    ]}
  />
);

export default AdminFaq;
